// import 'focus-visible';
import { Config } from 'src/types';
import { initSmartLook } from 'src/utilities/analytics';
import 'src/axiosRequest';
import 'src/index.css';
import { isProduction } from 'src/constants';
import 'src/exceptionReporting';
import SiteSettings from 'src/siteSetting';
import { isCookieAccepted } from 'src/utilities/storage';

export function commonInitialization(config: Config) {

  /*
   * Initialize Smartlook and Google Tag Manager
   */
  if (!SiteSettings.generalCookiePolicyConsent()) {
    initSmartLook(SiteSettings.generalSmartlookEnabled());
  } else {
    initSmartLook(isCookieAccepted() && SiteSettings.generalSmartlookEnabled());
  }
  
  if ((module as any).hot && !isProduction) {
    (module as any).hot.accept();
  }
}
